import { FetchBaseQueryArgs } from "@reduxjs/toolkit/dist/query/react";

export const baseQueryConfig: FetchBaseQueryArgs = {
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers: Headers) => {
    headers.set("Content-Type", "application/json");
    headers.set("Accept", "application/json");
    return headers;
  },
  mode: "cors",
};
